import React from 'react'
import UploadPresentation from '../../components/overlays/UploadPresentation'
import UpdatePresentation from '../../components/overlays/UpdatePresentation'
import DeletePresentation from '../../components/overlays/DeletePresentation'
import ConfirmationPopup from '../../components/overlays/ConfirmationPopup'
import LoadingPopup from '../../components/overlays/LoadingPopup'
import AddUser from '../../components/overlays/AddUser'
import AddCustomer from '../../components/overlays/AddCustomer'
import EditCustomer from '../../components/overlays/EditCustomer'
import EditPresentationInfo from '../../components/overlays/EditPresentationInfo'
import ResetPassword from '../../components/overlays/ResetPassword'
import EditUser from '../../components/overlays/EditUser'
import DeleteUser from '../../components/overlays/DeleteUser'
import ChangePassword from '../../components/overlays/ChangePassword'
import EditQuickPickPopupFunctional from '../../components/overlays/EditQuickPickPopupFunctional'
import ContactInfoPopup from '../../components/overlays/ContactInfoPopup'
import ProgressBarPopup from '../../components/overlays/ProgressBarPopup'
import DemoPopup from '../../components/overlays/DemoPopup'
import SlideViewPopup from '../../components/overlays/SlideViewPopup'
import RegisterUser from '../../components/overlays/RegisterUser'
import AddTeam from '../../components/overlays/AddTeam'
import EditTeam from '../../components/overlays/EditTeam'
import SheetViewPopup from '../../components/overlays/SheetViewPopup'
import ChartQueryPopup from '../../components/overlays/ChartQueryPopup'
import DBupload from '../../components/overlays/DBupload'
import DBuploadCompleted from '../../components/overlays/DBuploadCompleted'
import AddEditFolder from '../../components/overlays/AddEditFolder'
import DeleteFolder from '../../components/overlays/DeleteFolder'
import AddEditDatabase from '../../components/overlays/AddEditDatabase'
import CreateDatabase from '../../components/overlays/CreateDatabase'
import DeleteDatabase from '../../components/overlays/DeleteDatabase'
import WebUpload from '../../components/overlays/WebUpload'
import CreateStoryPopup from '../../components/overlays/CreateStoryPopup'
import SlideHistoryPopup from '../../components/overlays/SlideHistoryPopup'
import EditStoryPopup from '../../components/overlays/EditStoryPopup'
import DeleteDbJob from '../../components/overlays/DeleteDbJob'
import DeleteDbJobFile from '../../components/overlays/DeleteDbJobFile'
import InfoDbJob from '../../components/overlays/InfoDbJob'
import FireDbJob from '../../components/overlays/FireDbJob'
import ViewDbJobLog from '../../components/overlays/ViewDbJobLog'
import DataToolsTaskList from '../../components/overlays/DataToolsTaskList'
import DatabaseJobFileUpload from '../../components/overlays/DatabaseJobFileUpload'
import LookInsideZipFile from '../../components/overlays/LookInsideZipFile'
import AddEditProject from '../../components/overlays/AddEditProject'
import MoveDbJobToProject from '../../components/overlays/MoveDbJobToProject'

function PopupFormContainer(props) {
    const formDictionary = {
        "uploadPresentation": <UploadPresentation />,
        "updatePresentation": <UpdatePresentation />,
        "deletePresentation": <DeletePresentation />,
        "confirmationPopup": <ConfirmationPopup />,
        "loadingPopup": <LoadingPopup />,
        "addUser": <AddUser customerList={props.popupInfo} />,
        "addCustomer": <AddCustomer />,
        "editCustomer": <EditCustomer customerList={props.popupInfo} />,
        "editPresentationInfo": <EditPresentationInfo presID={props.popupInfo} />,
        "resetPassword": <ResetPassword />,
        "editUser": <EditUser />,
        "deleteUser": <DeleteUser />,
        "changePassword": <ChangePassword />,
        "qpPopup": <EditQuickPickPopupFunctional />,
        "contactInfoPopup": <ContactInfoPopup />,
        "progressBarPopup": <ProgressBarPopup />,
        "demoPopup": <DemoPopup />,
        "slideViewPopup": <SlideViewPopup />,
        "sheetViewPopup": <SheetViewPopup />,
        "registerUser": <RegisterUser />,
        "addTeam": <AddTeam customerList={props.popupInfo} />,
        "editTeam": <EditTeam />,
        "chartQueryPopup": <ChartQueryPopup />,
        "SlideHistoryPopup": <SlideHistoryPopup />,
        "DBupload": <DBupload />,
        "DBuploadCompleted": <DBuploadCompleted />,
        "addeditFolder": <AddEditFolder />,
        "deleteFolder": <DeleteFolder />,
        "addeditDatabase": <AddEditDatabase />,
        "createDatabase": <CreateDatabase />,
        "deleteDatabase": <DeleteDatabase />,
        "WebUpload": <WebUpload />,
        "CreateStoryPopup": <CreateStoryPopup />,
        "EditStoryPopup": <EditStoryPopup />,
        "deleteDbJob": <DeleteDbJob />,
        "deleteDbJobFile": <DeleteDbJobFile />,
        "infoDbJob": <InfoDbJob />,
        "fireDbJob": <FireDbJob />,
        "viewDbJobLog": <ViewDbJobLog />,
        "dataToolsTaskList": <DataToolsTaskList />,
        "databaseJobFileUpload": <DatabaseJobFileUpload />,
        "lookInsideZipFile": <LookInsideZipFile />,
        "addEditProject": <AddEditProject />,
        "moveDbJobToProject": <MoveDbJobToProject />
    }
    return (formDictionary[props.popup]);
}

export default PopupFormContainer